import {cleanFields} from '../../../utilities/helper/cleanFields';
import request from '../../axios';

const PatchEmployeeAdvertisement = async (
  payload: IEmployeeAdvertisementPayload,
  guid?: string,
) => {
  const newPayload = {
    ad_type: payload.ad_type,
    srs_type: payload.srs_type?.type,
    name: payload.name,
    title: payload.title,
    sub_input: payload.sub_input?.guid,
    description: payload?.description || null,
    ad_price: payload.negotiated_price ? null : payload.ad_price,
    // price_on_call: payload?.price_on_call || false,
    profile_type: 'supplier',
    type: payload?.type?.value,
    price_unit: payload.price_unit?.value || null,
    negotiated_price: payload?.negotiated_price || false,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    from_date: payload?.from_date || null,
    to_date: payload?.to_date || null,
    exclude_holydays: payload?.exclude_holydays || null,
    exclude_fridays: payload?.exclude_fridays || null,
    age: payload?.age || null,
    hide_phone_number: payload?.hide_phone_number,
    job_experience: payload?.job_experience || null,
    from_hour: payload?.from_hour?.guid || null,
    gender: payload?.gender?.guid || null,
    to_hour: payload?.to_hour?.guid || null,
    images_id: payload?.images?.map(item => item).toString() || null,
    main_image_id: payload?.main_image || null,
    has_discount: payload?.has_discount || null,
    discount_amount: payload?.discount_amount || null,
    filter: 'advertisement',
    only_massage_buyer: payload.only_massage_buyer || false,
  };

  // ✅ specify which fields to check/remove if null
  const cleanedPayload = cleanFields(newPayload);

  const response = await request.patch(`api/v2/store/advertisement/${guid}`, {
    ...cleanedPayload,
  });

  return response.data;
};

export default PatchEmployeeAdvertisement;
